/// <reference path='../modules/blocks.router.module.ts'/>

module Blocks {
    export interface IRouterHelperProvider extends ng.IServiceProvider {
        config: {
            $stateProvider: angular.ui.IStateProvider;
            docTitle: string;
            resolveAlways: { ready: {} };
        };
    }

    export class RouterHelperProvider implements IRouterHelperProvider {
        static providerId: string = 'routehelperConfig';

        config = {
            $stateProvider: null,
            docTitle: '',
            resolveAlways: { ready: () => { } }
        }

        $get = () => {
            return { config: this.config };
        }
    }

    router.provider(RouterHelperProvider.providerId, RouterHelperProvider);
}